export default "__VITE_ASSET__CHa3ETsF__"